import { apiClientBff } from './apiBff';

export interface AnimalPassportData {
  _id: string;
  _key: string;
  _rev: string;
  birth_date?: string;
  birth_farm_id?: string;
  birth_weight_kg?: number | null;
  breed_code?: string;
  cattle_id?: {
    tag?: string;
    country_code?: string;
    manufacturer_code?: number;
    unique_id?: string;
  };
  createdAt?: string;
  created_at?: string;
  current_farm_id?: string;
  current_paddock_id?: string | null;
  current_status?: string;
  farm_id?: string;
  gender?: string;
  name?: string;
  title?: string;
  updatedAt?: string;
  updated_at?: string;
  handling_history?: Array<{
    _key: string;
    _id: string;
    _rev: string;
    farm_id: string;
    cattle_tag: string;
    handling_type_code: string;
    title?: string;
    handling_date: string;
    handling_details?: any;
    created_at?: string;
    updated_at?: string;
    createdAt?: string;
    updatedAt?: string;
  }>;
}

export const getAnimalPassport = async (cattleTag: string, farmId: string): Promise<AnimalPassportData> => {
  const response = await apiClientBff.post('/cattle/passport', {
    cattle_tag: cattleTag,
    farm_id: farmId
  }) as any;
  
  // A estrutura do axios/apiClient retorna os dados em response.data
  // O backend retorna { data: { ... } }
  // Portanto, o dado real pode estar em response.data (se o apiClient já extrai o data) ou response.data.data
  
  if (response.data && response.data.data) {
    return response.data.data;
  }
  
  if (response.data) {
     return response.data;
  }

  return response as unknown as AnimalPassportData;
};
